import shopifyEnterpriseGenericDefaults from '../shopify-enterprise-generic/config.js';
import { ConvermaxProductForm } from './productForm.js';

function onVerifyFitmentResponseReceived(response) {
  const titleElement = window.document.querySelector('.product-info__title');

  if (!response.Items?.length || !titleElement) {
    titleElement.querySelector('.product-label-fitment')?.remove();
    return;
  }

  const [{ fitsTheVehicle, verify_fitment_info: { Notes, Position } = {} }] = response.Items;

  if (fitsTheVehicle !== 'yes' || (!Notes && !Position)) {
    titleElement.querySelector('.product-label-fitment')?.remove();
    return;
  }

  const badges = `
    ${Notes ? `<span class="product-label product-label--custom product-label--notes">${Notes.join(', ')}</span>` : ''}
    ${Position ? `<span class="product-label product-label--custom product-label--position">${Position.join(', ')}</span>` : ''}
  `;

  let verify = titleElement.querySelector('.product-label-fitment');

  if (verify) {
    verify.innerHTML = badges;
  } else {
    verify = window.document.createElement('div');
    verify.classList.add(
      'product-label-wrapper',
      'product-label-fitment',
      'flex',
      'flex-row',
      'flex-wrap',
      'gap-3',
    );
    verify.innerHTML = badges;

    titleElement.appendChild(verify);
  }
}

function InitFunc() {
  shopifyEnterpriseGenericDefaults.InitFunc();

  if (!window.customElements.get('convermax-product-form')) {
    window.customElements.define('convermax-product-form', ConvermaxProductForm);
  }
}

export default {
  includes: ['shopify-enterprise-generic'],
  ...shopifyEnterpriseGenericDefaults,
  InitFunc,
  autocomplete: {
    order: ['product', 'facetValue'],
  },
  fitmentSearch: {
    ...shopifyEnterpriseGenericDefaults.fitmentSearch,
    onVerifyFitmentResponseReceived,
    onVerifyFitmentInitResponseReceived: onVerifyFitmentResponseReceived,
  },
  Widgets: [
    ...shopifyEnterpriseGenericDefaults.Widgets.filter(
      (w) => !['HeaderVehicleWidget', 'VerifyFitment'].includes(w.name),
    ),
    {
      ...shopifyEnterpriseGenericDefaults.Widgets.find((f) => f.name === 'HeaderVehicleWidget'),
      template: 'fitmentSearch/homeVehicleWidget',
      isAlwaysColumnLayout: window.innerWidth < 1088,
      initCollapsed: true,
    },
    {
      ...shopifyEnterpriseGenericDefaults.Widgets.find((f) => f.name === 'VerifyFitment'),
      template: 'fitmentSearch/verifyFitment',
      isAlwaysColumnLayout: true,
    },
  ],
};
